export var IdCollectCategory;
(function (IdCollectCategory) {
    IdCollectCategory[IdCollectCategory["LeagueOverview"] = 46] = "LeagueOverview";
    IdCollectCategory[IdCollectCategory["CollectLeague"] = 39] = "CollectLeague";
    IdCollectCategory[IdCollectCategory["LeagueRanking"] = 45] = "LeagueRanking";
})(IdCollectCategory || (IdCollectCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdCollectCategory.ts
// module id = 607
// module chunks = 3